import type { MoneyRecord } from '@navio/nsdk';
import { cn } from 'noddi-ui-common';
import { formatCurrencyAmount } from 'noddi-util';

type Props = {
  price: MoneyRecord;
  lineTotalGross?: MoneyRecord;
  hasDiscounts: boolean;
  className?: string;
};

/** A discounted line shows its gross struck through above what is owed after discounts. */
export const OrderLinePrice = ({ price, lineTotalGross, hasDiscounts, className }: Props) => {
  if (!hasDiscounts) {
    return <span className={className}>{formatCurrencyAmount({ money: price })}</span>;
  }
  return (
    <div className={cn('flex flex-col items-end gap-0.5', className)}>
      <span className='text-muted-foreground line-through'>{formatCurrencyAmount({ money: price })}</span>
      <span className='font-semibold'>{formatCurrencyAmount({ money: lineTotalGross ?? price })}</span>
    </div>
  );
};
